import { FeaturedWorkout, Workout, WorkoutIntensity } from 'src/dao/core-dao'

/**
 * Adapt a `FeaturedWorkout` to the `Workout` shape the shared card primitives are typed
 * against.
 *
 * The adaptation happens here rather than by widening `WorkoutCard`'s prop type, so the ~20
 * existing consumers of the card system are untouched. The featured payload is deliberately
 * thinner than `Workout` — it is built for a signed-out visitor — so the fields below that it
 * cannot supply are filled with inert values. None of them is read by any primitive the
 * featured card composes (`Image`, `Content`, `Title`, `Trainer`, `Duration`); they exist only
 * to satisfy the type.
 *
 * The one load-bearing line is the trainer mapping: `name` → `firstName` is what lets
 * `WorkoutCardTrainer` run in `payload` mode and skip the guarded `/trainers` lookup.
 */
export const featuredWorkoutToCardWorkout = (featured: FeaturedWorkout): Workout => ({
  id: featured.id,
  title: featured.title,
  description: featured.description,
  imagePublicFileId: featured.imagePublicFileId ?? '',
  videoUrl: featured.videoUrl,
  durationId: featured.durationId,
  duration: featured.duration,
  intensityId: featured.intensityId,
  intensity: (featured.intensity as WorkoutIntensity) || WorkoutIntensity.MEDIUM,
  trainers: featured.trainers.map((trainer) => ({ id: trainer.id, firstName: trainer.name })),

  // Not carried by the featured payload, not read by the composed card.
  typeId: '',
  bodyPartIds: [],
  availableAt: '',
  equipment: [],
})
